import { render, staticRenderFns } from "./DesktopCreator.vue?vue&type=template&id=18156111&scoped=true&"
import script from "./DesktopCreator.vue?vue&type=script&lang=js&"
export * from "./DesktopCreator.vue?vue&type=script&lang=js&"
import style0 from "./DesktopCreator.vue?vue&type=style&index=0&id=18156111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18156111",
  null
  
)

export default component.exports